<template>
  <div class="log-security">
    <main>

      <a-row style="padding:0 20px;">
        <a-form-model :model="securityForm" :rules="securityFormRules" :layout="formLayout" ref="securityForm"  style="margin-top: 15px">

          <a-col :span="20" >
            <label class="security-title">密码复杂度</label>
            <a-form-model-item  prop="passwordComplexity" style="margin-left: 15px;">
              <a-radio-group v-model="securityForm.passwordComplexity" class="radio-password" @change="choiceChange">
                <a-radio value="1">
                  必须包含数字、英文字母(A-Z或a-z)
                </a-radio>
                <a-radio value="2">
                  必须包含数字、英文字母(A-Z或a-z)和特殊字符()~!@#$%^&*_-+=|{}[]:;<>,.?/
                </a-radio>
                <a-radio value="3">
                  必须包含数字、大写和小写英文字母(A-Z或a-z)以及特殊字符()~!@#$%^&*_-+=|{}[]:;<>,.?/
                </a-radio>
              </a-radio-group>
            </a-form-model-item>


          </a-col>


          <a-col :span="20" style="margin-top: -15px;">
           <label  class="security-title">安全策略设计</label>

            <a-form-model-item label="密码长度最小值" prop="passwordLength" style="margin-left: 15px;">
              <label>密码至少</label>
              <a-input-number
                  style="margin: 0 5px"
                  v-model="securityForm.passwordLength"
                  placeholder="请输入"
                  :min="6"
                  :max="15"
                  @change="choiceChange"
              />
              <label>个字符 </label>
              <span> (值必须介于6到15之间)</span>
            </a-form-model-item>





          </a-col>
          <a-col :span="20" >
            <label style="margin: 0 0 10px 15px;font-weight: 600; display: inline-block;"><span class="required"></span>防破解</label>
             <div style="display: flex;">
               <a-form-model-item  prop="number" style="margin-left: 15px;">
                 <label>密码连续错误次数大于等于</label>
                 <a-input-number
                     style="margin: 0 5px"
                     v-model="securityForm.number"
                     placeholder="请输入"
                     :min="2"
                     :max="10"
                     @change="choiceChange"
                 />
                 <label>次</label>
                 <span> (值必须介于2到10之间)</span>
               </a-form-model-item>


               <a-form-model-item  prop="freezeTime" style="margin-left: 15px;">
                 <label>账号冻结</label>
                 <a-input-number
                     style="margin: 0 5px"
                     v-model="securityForm.freezeTime"
                     placeholder="请输入"
                     :min="15"
                     :max="1440"
                     @change="choiceChange"
                 />
                 <label>分钟</label>
                 <span> (值必须介于15到1440之间)</span>
               </a-form-model-item>

             </div>

          </a-col>

          <a-col :span="20" >
              <a-form-model-item label="有效期"  prop="validityDate" style="margin-left: 15px;">
                <a-radio-group v-model="securityForm.validityDate"     @change="choiceChange">
                  <a-radio value="60">
                   60天
                  </a-radio>
                  <a-radio value="90">
                 90天
                  </a-radio>
                  <a-radio value="180">
                   180天
                  </a-radio>
                  <a-radio value="0">
                    永不过期
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>




          </a-col>



          <a-col :span="24" class="sysSet-operate">
            <a-form-model-item >
              <a-button type="primary"  @click="securitySubmit" :loading="submitLoad" style="color: #ffffff">
                保存
              </a-button>
            </a-form-model-item>

          </a-col>
        </a-form-model>
      </a-row>


    </main>
  </div>
</template>

<script>
import {notification} from "ant-design-vue";

export default {
  data() {
    return {
      btnLoad: false,
      submitLoad: false,
      loading: false,
      securityForm:{
        freezeTime:'',
        number:'',
        passwordComplexity:'1',
        passwordLength:'',
        validityDate:'60',
      },
      securityFormRules:{
        validityDate: [{ required: true, message: "有效期不能为空" }],
        number: [{ required: true, message: "密码错误次数不能为空" }],
        freezeTime: [{ required: true, message: "冻结时间不能为空" }],
        passwordLength: [{ required: true, message: "密码长度不能为空" }],
      },
      formLayout:"vertical",
    };
  },
  methods: {
    choiceChange(){
      this.$emit('childMessage','未保存')
    },
    // 回显天数
    echoLogList(){
      this.axios
          .post('/getAccountPolicy')
          .then((res) => {
            if (res.code === 200) {
               this.securityForm = res.data

               this.$cookies.set('getAccountPolicy',JSON.stringify(res.data),"1d",'/')
               this.$store.commit('user/getAccountPolicyInfo')
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },


    // 保存
    securitySubmit(){
      this.$refs.securityForm.validate((valid) => {
        if (valid) {
          this.securityForm.freezeTime = String(this.securityForm.freezeTime)
          this.securityForm.number = String(this.securityForm.number)
          this.securityForm.passwordLength = String(this.securityForm.passwordLength)
          this.axios
              .post('/saveAccountPolicy',  this.securityForm)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.$cookies.set('getAccountPolicy',JSON.stringify(this.securityForm),"1d",'/')
                  this.$store.commit('user/getAccountPolicyInfo')
                  this.$emit('childMessage','保存成功')
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  beforeMount() {
    this.echoLogList()
  },
};
</script>

<style lang="scss" scoped>
.log-security {
  header {
    display: flex;
    align-items: flex-end;
    margin: -7px -8px 0;
    padding: 16px;
    letter-spacing: 1px;
    background-color: #fff;

    h3 {
      margin-bottom: 0;
      line-height: 20px;
      padding-left: 12px;
      border-left: 4px solid #3373f2;
      font-size: 18px;
      //font-weight: bold;
    }

    span {
      line-height: 16px;
      margin-left: 10px;
      color: #808080;
    }
  }

  main {
    margin: 16px 0px;
    background-color: #fff;
    //   padding: 0 16px;
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.07),
    0 1px 10px 0 rgba(0, 0, 0, 0.06);
    border-radius: 4px;

    ::v-deep .ant-form-item-label{
      font-weight: 600;
      margin-bottom: 10px;
    }
    .ant-form-item label{
      font-weight: 600;

    }
    .ant-form-item{

    }
    .security-title{
      display: inline-block;
      font-weight: 600;
      color:#222222;
      font-size: 16px;
      margin-bottom: 20px;
    }
    .radio-password{
      display: flex;
      flex-direction: column;
      .ant-radio-wrapper{
        margin-bottom: 10px;
      }
    }




    //按钮
    .sysSet-operate{
      text-align: right;
      margin-top: 180px;
      .ant-btn:nth-child(1){
        margin-right: 15px;
        background-color: #ecf0fe;
        color: #3373f2;
        letter-spacing: 1px;
      }
      .ant-btn:nth-child(2){
        width: 70px;
      }
    }


    .required::before {
    display: inline-block;
    margin-right: 4px;
    color: #f5222d;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    content: '*';
  }
  }
}
</style>
